
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class MainNavItem extends Vue {
    @Prop() private active!: boolean;
}
